import React, { type FC } from 'react';

import { withAnalyticsEvents } from '@atlaskit/analytics-next';

import { fg } from '@confluence/feature-gating';

import { StickyWrapper } from './StickyWrapper';

const StickyBannerInner = withAnalyticsEvents()(StickyWrapper);

export const StickyBanner: FC<{ children: React.ReactNode }> = (props) => {
	return fg('remove_stickybanner_and_stickywrapper') ? (
		<>{props.children}</>
	) : (
		<StickyBannerInner {...props} />
	);
};
